export default __webpack_public_path__ + "static/media/aboutme.5e6373b5.png";